'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var Tree = require('./Tree.jsx');
var Options = require('./Options.jsx');
var i18n = require('../helper/i18n');

var assetsHelper = require('../helper/assetsHelper');
var dataHelper = require('../helper/dataHelper');
var Resizer = require('./Resizer');
var QrCode = require('./QrCode');
var runtimeHelper = require('../helper/runtimeHelper');

var PreviewPanel = React.createClass({
  propTypes: {
    app: React.PropTypes.object,
    domSize: React.PropTypes.object,
    current: React.PropTypes.object.isRequired,
    showComments: React.PropTypes.bool.isRequired,
    alwaysShowLinks: React.PropTypes.bool.isRequired,
    hoverShowLinks: React.PropTypes.bool.isRequired,
    hoverShowRemarks: React.PropTypes.bool.isRequired,
    showPanel: React.PropTypes.bool.isRequired,
    showQRCode: React.PropTypes.bool.isRequired,
    onOpenPage: React.PropTypes.func.isRequired,
    onScaleChange: React.PropTypes.func.isRequired,
    onShowComments: React.PropTypes.func.isRequired,
    onShowReview: React.PropTypes.func.isRequired,
    onAlwaysShowLinks: React.PropTypes.func.isRequired,
    onHoverShowLinks: React.PropTypes.func.isRequired,
    onHoverShowRemarks: React.PropTypes.func.isRequired,
    onSetPanelVisibility: React.PropTypes.func.isRequired,
    showCommentsBoard: React.PropTypes.func.isRequired,
    showQrCode: React.PropTypes.bool.isRequired,
  },
  getInitialState: function () {
    return {
      showOptions: true,
      showQRCode: true,
    };
  },
  componentDidMount: function () {
    this.setPagesHeight();
  },
  componentDidUpdate: function () {
    this.setPagesHeight();
  },
  setPagesHeight: function () {
    var size = this.props.domSize;
    var remainHeight = size.height - this.getHeight('header') - this.getHeight('name') - this.getHeight('options') - this.getHeight('control') - this.getHeight('qrcode') - 60;
    if (remainHeight > 0) {
      ReactDOM.findDOMNode(this.refs.pages).style.height = remainHeight + 'px';
    }
  },
  getHeight: function (ref) {
    return ReactDOM.findDOMNode(this.refs[ref]).getBoundingClientRect().height;
  },
  render: function () {
    var app = this.props.app;
    var style = {};
    var optionStyle = {};
    var toggleButtonStyle = {};

    style.marginLeft = this.props.showPanel ? 0 : -260;

    if (!this.state.showOptions) {
      optionStyle.display = 'none';
      toggleButtonStyle.transform = 'rotate(180deg)';
    }

    return (
      <div className='pc-preview-panel preview-panel' style={style}>
        <div ref="header" className="header">
          <h2 className="app-name">{app.name}</h2>
          {runtimeHelper.canReview() &&
          <img onClick={this.props.showCommentsBoard} className='message' src={assetsHelper.getAsset('review/show_comments.png')}/>
          }
          <img onClick={this.onClosePanel} className="close" src={assetsHelper.getAsset('close-30.png')}/>
        </div>
        <h3 ref="name" className="page-name">{this.currentPageName()}</h3>
        <div ref="control" className="scale-and-control">
          <Resizer value={this.props.scale} onChange={this.onScaleChange}/>

          <span className="reset" onClick={this.onScaleReset}><img width="16" height="16"
                                                                   src={assetsHelper.getAsset('reset.png')}/></span>

          <span className="toggle-options" onClick={this.toggleOptions}>
            <img src={assetsHelper.getAsset('expand.png')} style={toggleButtonStyle}/>
          </span>
        </div>
        <div ref="options" className="preview-options-section" style={optionStyle}>
          <Options
            showComments={this.props.showComments}
            alwaysShowLinks={this.props.alwaysShowLinks}
            hoverShowLinks={this.props.hoverShowLinks}
            hoverShowRemarks={this.props.hoverShowRemarks}
            onShowComments={this.props.onShowComments}
            onAlwaysShowLinks={this.props.onAlwaysShowLinks}
            onHoverShowLinks={this.props.onHoverShowLinks}
            onHoverShowRemarks={this.props.onHoverShowRemarks}
          />
        </div>
        <div className="pages" ref="pages">
          <Tree
            name={this.props.app.name}
            current={this.props.current}
            modules={app.modules}
            onSelectPage={this.props.onOpenPage}/>
        </div>
        {this.renderQrCode()}
      </div>
    );
  },
  renderQrCode: function () {
    var QRCodeStyle = {display: "none"};
    var toggleQRCodeStyle = {};
    var showQrCode = this.state.showQRCode && dataHelper.isHttpURL();
    var platform = this.props.app.params.projectParam.platform;

    if (showQrCode) {
      QRCodeStyle.display = 'block';
      toggleQRCodeStyle.transform = 'rotate(180deg)';
    }

    if (this.props.showQrCode && dataHelper.isHttpURL() && (platform === 'MtMobile' || platform === 'MtPad')) {
      return (
        <div className="my-qr-code" ref="qrcode">

          <div className="toggle-qr-box">
            <span className="toggle-QRCode" onClick={this.toggleQRCode}>
              <img src={assetsHelper.getAsset('expand.png')} style={toggleQRCodeStyle}/>
            </span>
          </div>

          <div style={QRCodeStyle}>
            <QrCode URL={window.location.href} width={80} height={80}/>
            <p className="desc">{i18n.get('QRCODE')}</p>
          </div>

        </div>
      );
    }
    return (<div ref="qrcode"></div>);
  },
  onScaleChange: function (value) {
    this.props.onScaleChange(value);
  },
  onScaleReset: function () {
    this.props.onScaleChange(1);
  },
  toggleOptions: function () {
    this.setState({
      showOptions: !this.state.showOptions
    });
  },
  toggleQRCode: function () {
    this.setState({
      showQRCode: !this.state.showQRCode
    })
  },
  onClosePanel: function () {
    this.props.onSetPanelVisibility(false);
  },
  currentPageName: function () {
    return this.props.current.title;
  }
});

module.exports = PreviewPanel;



// WEBPACK FOOTER //
// ./src/views/PreviewPanel.jsx